export default "__VITE_ASSET__BiWk1h9O__"